import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
    ApiService,
    Mk2Request,
    Mk2Response,
    Pagination
} from '@lsq-frontend/angular-shared/api-service';
import { ISettings, SETTINGS } from '@lsq-frontend/angular-shared/settings';
import { MoneyDto } from '../../model/money-dto';

export class GetSupplierBasicInformationRequest extends Mk2Request {
    supplierKey?: string;

    constructor(initial?: Partial<GetSupplierBasicInformationRequest>) {
        super();
        if (initial != null) {
            Object.keys(initial).forEach((key) => {
                this[key] = initial[key];
            });
        }
    }
}

export class GetSupplierProgramInformationResponse extends Mk2Response {
    buyerPaidEarlyPaymentFeePercentage?: number;
    buyerPaidEarlyPaymentFeePercentageVisible?: boolean;
    earlyPaidAvgDays?: string;
    enrollmentDate?: any;
    percentUsed?: string;
    status?: 'UNKNOWN' | 'ENROLLED' | 'INELIGIBLE' | 'NOT_ENROLLED';
    totalOpenInvoices?: number;
    totalPaidFees?: MoneyDto;

    constructor(initial?: Partial<GetSupplierProgramInformationResponse>) {
        super();
        if (initial != null) {
            Object.keys(initial).forEach((key) => {
                this[key] = initial[key];
            });
        }
    }
}

@Injectable({ providedIn: 'root' })
export class GetSupplierProgramInformationService extends ApiService<
    GetSupplierBasicInformationRequest,
    GetSupplierProgramInformationResponse
> {
    public requestType = GetSupplierBasicInformationRequest;
    public responseType = GetSupplierProgramInformationResponse;
    public endpointName = 'BuyerAccount/SupplierDetails/GetSupplierProgramInformation';
    public serviceName = 'financing';
    constructor(http: HttpClient, @Inject(SETTINGS) settings: ISettings) {
        super(http, settings);
    }
}
